import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	QueryList,
	TemplateRef,
	ViewChild,
	ViewChildren
} from '@angular/core';
import {
	FormBuilder,
	FormControl,
	FormGroup,
	Validators
} from '@angular/forms';
import { CalendarDateFormatter, CalendarEvent } from 'angular-calendar';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { forkJoin, Observable } from 'rxjs';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Vacation, VacationType } from 'src/app/shared/models/vacation';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Mission } from 'src/app/shared/models/mission/mission';
import { Planning } from 'src/app/shared/models/planning';
import { Solution } from 'src/app/shared/models/solution';
import { Specialite } from 'src/app/shared/models/specialite';
import { User } from 'src/app/shared/models/security/user';
import { Vehicle } from 'src/app/shared/models/vehicle';
import { CustomDateFormatter } from 'src/app/shared/utils/custom-date-formatter';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION,
	MISSION_TYPE_REUNION_TYPE,
	MISSION_TYPE_PRESCRIPTION
} from 'src/app/core/services/constant/constants.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Authority } from 'src/app/shared/models/security/authority';
import {
	ErrorResponse,
	ErrorResponseWithMissionBody
} from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { OverlappingResponse } from 'src/app/shared/models/api-response/overlapping-response';
import { State } from 'src/app/shared/enums/state.enum';
import { MissionTypeName } from 'src/app/shared/enums/mission-type-name.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { Route } from 'src/app/shared/models/route';
import { ResolveConflictModalComponent } from 'src/app/shared/components/resolve-conflict-modal/resolve-conflict-modal.component';
import { Slot } from 'src/app/shared/models/services-aide-emploi/slot';
import {
	CompetencesElementaires,
	hasEmployeeSkill
} from 'src/app/shared/enums/competence.enum';
import { MissionRequest } from '../../../shared/models/mission/mission-request';

@Component({
	selector: 'app-event-edit',
	templateUrl: './event-edit.component.html',
	styleUrls: ['./event-edit.component.scss'],
	providers: [{ provide: CalendarDateFormatter, useClass: CustomDateFormatter }]
})
export class EventEditComponent implements OnInit {
	missionRequest: MissionRequest;
	isFormReadOnly = true;
	user: User = null;
	conflictMsg: string;
	modalEmployeeName: string;
	modalVehicleName: string;
	initialEmployee: Employee;
	initialVehicle: Vehicle;
	bsConfig: Partial<BsDatepickerConfig> = {
		containerClass: 'theme-dark-blue'
	};
	modalDataMission: {
		action: string;
		overlappingResponse: OverlappingResponse;
		mission: Mission;
		employee: Employee;
		prescriberRequest?: Slot;
		// missionTypeName: MissionTypeName;
	};
	modalDataRoute: {
		action: string;
		route: Route;
		employee: Employee;
	};
	missionObject: string; // Champ "objet" de la modal de la mission sélectionnée (ou réunion)
	planningOfItfc: Planning;
	modalForm: FormGroup;
	event: CalendarEvent = undefined;
	vacation: Vacation = undefined;

	@ViewChild('modalMissionDetail', { static: true })
	modalMissionDetail: TemplateRef<any>;
	@ViewChild('modalContentVacation', { static: true })
	modalContentVacation: TemplateRef<any>;
	@ViewChild('modalRouteDetail', { static: true })
	modalRouteDetail: TemplateRef<any>;

	missionTypeName: MissionTypeName;

	modalDataVacation: {
		action: string;
		vacation: Vacation;
		employee: Employee;
		datetimeStart: Date;
		datetimeEnd: Date;
	} = {
		action: '',
		vacation: null,
		employee: null,
		datetimeStart: new Date(),
		datetimeEnd: new Date()
	};

	// Alert modal
	@ViewChild('alertModal', { static: true }) alertModal: TemplateRef<any>;
	@ViewChild('confirmDeleteModal', { static: true })
	confirmDeleteModal: TemplateRef<any>;
	@ViewChild('confirmCancelModal', { static: true })
	confirmCancelModal: TemplateRef<any>;
	@ViewChild('confirmEditModal', { static: true })
	confirmEditModal: TemplateRef<any>;

	@Input() solution: Solution;
	@Input() selectedCalendarDate: Date;
	@Input() selectedWeek: number;
	@Input() vacationTypes: VacationType[];
	@Input() selectedServiceCenterId: number;

	@Output() getDataForPlanning: EventEmitter<any> = new EventEmitter();

	@ViewChild('accordionMission', { static: false })
	accordionMission: ElementRef;

	@ViewChildren('routeDropdownListing') routeDropdowns: QueryList<ElementRef>;

	bsModalResolveConflict: BsModalRef;

	// TODO: Commenter jusqu'au dev complet de la fonctionnalité
	vehiculeList: Vehicle[] = [];
	sauvegardeAncienVehiculeAssigne: Vehicle;
	isVehiculeActive: boolean;

	// Vacations edit
	vacationRangeDate: Date;

	labelIntervenantCapitalized: string;
	labelIntervenantPluralized: string;
	labelInterventionCapitalized: string;
	labelInterventionPluralized: string;
	labelIntervention: string;
	labelBeneficiaire: string;
	labelBeneficiaireCapitalized: string;
	isMissionPlacesActive: boolean;

	bsModalMissionDetail: BsModalRef;
	bsModalRouteDetail: BsModalRef;
	bsModalContentVacation: BsModalRef;
	bsModalAlert: BsModalRef;
	bsModalConfirmDelete: BsModalRef;
	bsModalConfirmCancel: BsModalRef;
	bsModalConfirmEdit: BsModalRef;

	MISSION_TYPE_REUNION_TYPE = MISSION_TYPE_REUNION_TYPE;
	MISSION_TYPE_PRESCRIPTION = MISSION_TYPE_PRESCRIPTION;

	isMobile = false;
	isPlanif = false;
	isIntervenant = true;

	isCancelButtonClicked = false;
	isAddingOrEditingVacationInProgress = false;
	isValidateBtnDisabled = false;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isSAE = false;

	Authority = Authority;

	reunionMembers: Employee[] = [];
	reunionMembersString: string[] = [];

	public StateMissionEnum = State;
	@Input() isEventEditable: boolean;

	// Pour le timepicker de modification d'horaire de mission (pour que l'user puisse mettre les vrais horaires une fois la mission réalisée)
	updatedStartMissionDate: Date = new Date();
	updatedEndMissionDate: Date = new Date();

	// Booléen pour bloquer la modification d'employee si la mission a déjà été réaliser
	hasMissionAlreadyHappened: boolean = true;
	initialStartDate: Date;
	initialEndDate: Date;

	// Obtention de la liste des intervenants filtrés (seulement ceux pas absents et pas indisponibles)
	employeesList: Employee[] = [];
	isStateOfMissionCanceled: boolean = false;
	missionHasBeenManuallyCanceled: boolean = false;

	mappingState = {
		UNDER_REVIEW: 'etude',
		PENDING: 'attente',
		IN_PROGRESS: 'en-cours'
	};
	eventMission: any;

	/* Pour détecter les missions synchronisées et avoir leurs liste de participants en string */
	isGroupMission: boolean;
	attendeesAsString: string[] | 'Aucun';

	/* Gestion de l'édition des notes */
	MAX_NOTES_LENGTH = 1023;
	notesForm = new FormGroup({
		notes: new FormControl('', Validators.maxLength(this.MAX_NOTES_LENGTH))
	});

	constructor(
		private logger: LogService,
		private formBuilder: FormBuilder,
		public bsModalService: BsModalService,
		public dateUtils: DateUtils,
		private facade: FacadeService,
		private route: ActivatedRoute,
		private toastService: ToastService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.isMobile =
			this.facade.mobileService.isMobile() || window.innerWidth < 1200;
		this.isPlanif = this.facade.dataStorageService.isPlanificatrice();
		this.isIntervenant = this.facade.dataStorageService.isIntervenant();
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelIntervenantPluralized =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelInterventionCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENTION
			);
		this.labelInterventionPluralized =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_INTERVENTION
			);
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
		this.labelBeneficiaire = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_BENEFICIAIRE
		);
		this.labelBeneficiaireCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.isSAE = this.facade.dataStorageService.isSAE();

		this.isVehiculeActive = this.facade.dataStorageService.isVehiculeActive();
		this.user = this.facade.dataStorageService.getUser();
		this.vacationRangeDate = this.selectedCalendarDate;

	}

	// typescript
	getMissionRequestAndInitializeFormData() {
		const formationId = this.modalDataMission?.mission?.missionRequest?.id ?? null;//+this.route.snapshot.paramMap.get('id');

		//console.log('[DEBUG] formationId =', this.modalDataMission.mission.id);

		this.facade.formationService.getFormationById(formationId).subscribe({
			next: (missionRequest: MissionRequest) => {
				this.missionRequest = missionRequest;
				//console.log('[DEBUG] missionRequest id =', this.missionRequest?.id);
				// ... reste de l'initialisation si logique en plus
			},
			error: (err) => {
				console.error('[DEBUG] getFormationById error:', err);
				// optionnel : afficher toast ou gestion d'erreur UI
			},
			complete: () => {
				console.log('[DEBUG] getFormationById completed');
			}
		});
	}


	/**
	 * Edit an event from list view
	 * @param missionSelected = mission selected in planning list view
	 * @param event
	 * @param id missionId
	 * @param action
	 */
	handleEventForListView(event, id, action) {
		//Liste des missions d'une tournée
		let missionsList = [...event.meta.route.missions];

		let missionSelected: Mission = missionsList.find((mission) => {
			return mission.missionRequest.id === id;
		});
		switch (missionSelected.missionRequest.missionType.type) {
			case MissionTypeName.REUNION:
				this.missionObject = MISSION_TYPE_REUNION_TYPE;
				this.getReunionMembers();
				break;

			case MissionTypeName.MISSION_ANNEXE:
				this.missionObject = MissionTypeName.MISSION_ANNEXE;
				break;

			default:
				this.missionObject =
					missionSelected.missionRequest.beneficiaire?.firstName +
					' ' +
					missionSelected.missionRequest.beneficiaire?.lastName;
				if (this.isSESSAD) {
					const careSkillNames =
						missionSelected.missionRequest.beneficiaire.careSkills
							.map((skill) => skill.name)
							.join(', ');

					this.missionObject += ` (${careSkillNames})`;
				}
				break;
		}

		// Heure de début/fin de mission
		const realStartValue = missionSelected.realStart;
		const startHour = Math.floor(realStartValue / 60);
		const startMinutes = Math.round(realStartValue % 60);
		this.updatedStartMissionDate.setHours(startHour);
		this.updatedStartMissionDate.setMinutes(startMinutes);
		this.initialStartDate = new Date(this.updatedStartMissionDate);

		const realEndValue = missionSelected.realEnd;
		const endHour = Math.floor(realEndValue / 60);
		const endMinutes = Math.round(realEndValue % 60);
		this.updatedEndMissionDate.setHours(endHour);
		this.updatedEndMissionDate.setMinutes(endMinutes);
		this.initialEndDate = new Date(this.updatedEndMissionDate);

		this.hasMissionAlreadyHappened =
			new Date(missionSelected.missionRequest.date).getTime() +
				missionSelected.plannedEnd * 60 * 1000 <
			new Date().getTime();

		this.modalDataMission = {
			mission: missionSelected,
			action,
			employee: event.meta.employee || null,
			overlappingResponse: undefined
		};

		this.isStateOfMissionCanceled = missionSelected.state
			? State[missionSelected.state].includes(State.CANCELED)
			: false;

		this.facade.employeeService
			.getAllEmployeesAvailable(
				new Date(this.modalDataMission.mission.missionRequest.date),
				this.modalDataMission.mission.realStart,
				this.modalDataMission.mission.realEnd
			)
			.subscribe((employee: Employee[]) => {
				this.employeesList = employee;
				if (this.isSSIAD) {
					this.employeesList = this.employeesList.filter((employee) => {
						return (
							hasEmployeeSkill(employee, CompetencesElementaires.INFIRMIER) ||
							hasEmployeeSkill(employee, CompetencesElementaires.AIDESOIGNANT)
						);
					});
				}
			});

		this.modalForm = this.formBuilder.group({
			date: new Date(missionSelected.missionRequest.date),
			realStart: this.dateUtils.timeConvert(missionSelected.realStart),
			realEnd: this.dateUtils.timeConvert(missionSelected.realEnd),
			readyTime: this.dateUtils.timeConvert(
				missionSelected.missionRequest.readyTime
			),
			dueTime: this.dateUtils.timeConvert(
				missionSelected.missionRequest.dueTime
			)
		});
		if (event.meta.employee) {
			this.modalEmployeeName =
				event.meta.employee.firstName + ' ' + event.meta.employee.lastName;
		}
		this.bsModalMissionDetail = this.bsModalService.show(
			this.modalMissionDetail,
			{ class: 'modal-lg' }
		);
	}

	/**
	 * Edit an event
	 * @param action = string (Edited, Clicked, ... not use anymore)
	 * @param event = CalendarEvent: contains in event.meta infos about mission/formation/employee/...
	 */
	handleEvent(action: string, event: CalendarEvent, id?: number): void {
		this.event = event;

		if (event.meta?.mission) {
			this.handleMissionEvent(action, event);
		} else if (event.meta?.route) {
			this.handleRouteEvent(action, event, id);
		} else if (event.meta?.vacation) {
			this.handleVacationEvent(event);
		}

		this.updateNotesForm(event);
	}

	private handleMissionEvent(action: string, event: CalendarEvent) {
		const mission: Mission = event.meta.mission;
		this.isGroupMission = mission.missionRequest.nombreIntervenant > 1;
		this.setAttendeesAsString(mission);
		// Reset le booléen ici car on ne passe plus dans le ngOnInit
		this.missionHasBeenManuallyCanceled = false;
		if (event.meta?.mission) {
			this.modalDataMission = {
				action: action,
				mission,
				employee: event.meta.employee || null,
				overlappingResponse: undefined
			};
			this.getMissionRequestAndInitializeFormData();
			if (
				this.isSAE &&
				mission.missionRequest.missionType.type === MISSION_TYPE_PRESCRIPTION
			) {
				this.fetchPrescriberRequest(mission, event);
			}
			this.setMissionObject(mission);
			this.updateMissionDates(event);
			this.hasMissionAlreadyHappened =
				this.checkIfMissionHasAlreadyHappened(mission);
			this.fetchEmployeesForMission(mission);
			this.initializeModalForm(mission);
			this.openMissionModal();
		}
	}

	private handleRouteEvent(
		action: string,
		event: CalendarEvent,
		id?: number
	): void {
		this.getVehicules();
		this.modalDataRoute = {
			action: action,
			employee: event.meta.employee,
			route: event.meta.route
		};
		this.bsModalRouteDetail = this.bsModalService.show(this.modalRouteDetail, {
			class: 'modal-lg'
		});
	}

	private handleVacationEvent(event: CalendarEvent): void {
		this.vacation = event.meta.vacation;
		this.modalDataVacation.employee = event?.meta?.employee;
		this.vacation.startDate = new Date(this.vacation.startDate);
		this.vacation.endDate = new Date(this.vacation.endDate);
		this.bsModalContentVacation = this.bsModalService.show(
			this.modalContentVacation,
			{ class: 'modal-lg' }
		);
	}

	private updateNotesForm(event: CalendarEvent): void {
		this.notesForm.patchValue(
			{ notes: event.meta.mission?.missionRequest.notes },
			{ onlySelf: true }
		);
	}

	private setAttendeesAsString(mission: Mission): void {
		const missionToUseForAttendees =
			this.isGroupMission && mission.missionParent
				? mission.missionParent
				: mission;
		this.attendeesAsString =
			missionToUseForAttendees.attendees &&
			missionToUseForAttendees.attendees.length > 0
				? missionToUseForAttendees.attendees.map(
						(attendee) => ` ${attendee.firstName} ${attendee.lastName}`
				  )
				: 'Aucun';
	}

	private fetchPrescriberRequest(mission: Mission, event: CalendarEvent): void {
		this.facade.prescriberService
			.getBookedAppointmentByMissionRequestId(mission.missionRequest.id)
			.subscribe({
				next: (prescriberRequest: Slot) => {
					event.meta.prescriberRequest = prescriberRequest;
					this.modalDataMission.prescriberRequest = prescriberRequest;
				},
				error: (e) => {}
			});
	}

	private setMissionObject(mission: Mission): void {
		switch (mission.missionRequest.missionType.type) {
			case MissionTypeName.REUNION:
				this.missionObject = MISSION_TYPE_REUNION_TYPE;
				this.getReunionMembers();
				break;

			case MissionTypeName.MISSION_ANNEXE:
				this.missionObject = MissionTypeName.MISSION_ANNEXE;
				break;

			case MissionTypeName.PRESCRIPTION:
				this.missionObject = MissionTypeName.PRESCRIPTION;
				break;

			default:
				this.missionObject = `${mission.missionRequest.beneficiaire?.firstName} ${mission.missionRequest.beneficiaire?.lastName}`;
				if (this.isSESSAD) {
					const careSkillNames = mission.missionRequest.beneficiaire.careSkills
						.map((skill) => skill.name)
						.join(', ');
					if (careSkillNames) {
						this.missionObject += ` (${careSkillNames})`;
					}
				}
				break;
		}
	}

	private updateMissionDates(event: CalendarEvent): void {
		const realStartValue = event.meta.mission.realStart;
		const startHour = Math.floor(realStartValue / 60);
		const startMinutes = Math.round(realStartValue % 60);
		this.updatedStartMissionDate.setHours(startHour);
		this.updatedStartMissionDate.setMinutes(startMinutes);
		this.initialStartDate = new Date(this.updatedStartMissionDate);

		const realEndValue = event.meta.mission.realEnd;
		const endHour = Math.floor(realEndValue / 60);
		const endMinutes = Math.round(realEndValue % 60);
		this.updatedEndMissionDate.setHours(endHour);
		this.updatedEndMissionDate.setMinutes(endMinutes);
		this.initialEndDate = new Date(this.updatedEndMissionDate);
	}

	private checkIfMissionHasAlreadyHappened(mission: Mission): boolean {
		return (
			new Date(mission.missionRequest.date).getTime() +
				mission.plannedEnd * 60 * 1000 <
			new Date().getTime()
		);
	}

	private fetchEmployeesForMission(mission: Mission): void {
		this.facade.employeeService
			.getAllEmployeesAvailable(
				new Date(mission.missionRequest.date),
				mission.realStart,
				mission.realEnd
			)
			.subscribe({
				next: (employee: Employee[]) => {
					this.employeesList = employee;
					if (this.isSSIAD) {
						this.employeesList = this.employeesList.filter((employee) => {
							return (
								hasEmployeeSkill(employee, CompetencesElementaires.INFIRMIER) ||
								hasEmployeeSkill(employee, CompetencesElementaires.AIDESOIGNANT)
							);
						});
					}
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
	}

	private initializeModalForm(mission: Mission): void {
		this.modalForm = this.formBuilder.group({
			date: new Date(mission.missionRequest.date),
			realStart: this.dateUtils.timeConvert(mission.realStart),
			realEnd: this.dateUtils.timeConvert(mission.realEnd),
			readyTime: this.dateUtils.timeConvert(mission.missionRequest.readyTime),
			dueTime: this.dateUtils.timeConvert(mission.missionRequest.dueTime)
		});

		if (mission.missionRequest) {
			if (this.isVehiculeActive) {
				this.getVehicules();
				this.modalDataMission.mission.route = this.findRouteByMissionId(
					this.solution,
					this.modalDataMission.mission.id
				);
				this.initialVehicle = this.modalDataMission.mission.route?.vehicle;
			}
		}
	}

	private openMissionModal(): void {
		this.bsModalMissionDetail = this.bsModalService.show(
			this.modalMissionDetail,
			{ class: 'modal-lg' }
		);
	}

	getMeetingLink() {
		if (this.modalDataMission?.prescriberRequest) {
			return this.modalDataMission.prescriberRequest.meetingLink;
		} else {
			return this.modalDataMission.mission.missionRequest.remoteLink;
		}
	}

	findRouteByMissionId(
		solution: Solution,
		missionId: number
	): Route | undefined {
		for (const planning of solution.plannings) {
			for (const route of planning.routes) {
				for (const mission of route.missions) {
					if (mission.id === missionId) {
						return route;
					}
				}
			}
		}
		return undefined;
	}

	/**
	 * teste si le careSkill de la mission est compatible avec le careSkill de l'employé
	 */
	isCareSkillMissionMatchingWithCareSkillEmp(): boolean {
		const careSkillsEmp = this.modalDataMission.employee.careSkills;
		const careSkillsMissionReq =
			this.modalDataMission.mission.missionRequest.careSkills;

		// Extraire les noms des compétences de l'employé
		const careSkillNamesEmp = careSkillsEmp.map((skill) => skill.name);

		// Vérifier que toutes les compétences requises par la mission sont présentes dans les compétences de l'employé
		return careSkillsMissionReq.every((skill) =>
			careSkillNamesEmp.includes(skill.name)
		);
	}

	isIntervenantCompatibleForBeneficiaire(): boolean {
		if (this.facade.dataStorageService.isPreferencesBeneficiaireActive()) {
			const beneficiaire =
				this.modalDataMission.mission.missionRequest.beneficiaire;
			if (
				beneficiaire &&
				(beneficiaire.incompatibleEmployee1 ||
					beneficiaire.incompatibleEmployee2 ||
					beneficiaire.incompatibleEmployee3)
			) {
				const empSelectedId = this.modalDataMission.employee.id;
				if (
					beneficiaire.incompatibleEmployee1?.id === empSelectedId ||
					beneficiaire.incompatibleEmployee2?.id === empSelectedId ||
					beneficiaire.incompatibleEmployee3?.id === empSelectedId
				) {
					return false;
				}
			}
		}
		return true;
	}

	getEmployeeSkillsAsString(employee: Employee): string {
		if (!employee) {
			return 'Aucun';
		}

		const skills = employee.careSkills;
		if (skills && skills.length > 0) {
			return skills.map((skill) => skill.name || 'Sans').join(' | ');
		}

		return 'Sans';
	}

	getEmployeeDisplayName(employee: Employee): string {
		if (!employee) {
			return 'Aucun';
		}
		return `${employee.firstName} ${
			employee.lastName
		} - ${this.getEmployeeSkillsAsString(employee)}`;
	}

	shouldShowEmployee(): boolean {
		return (
			!this.isGroupMission &&
			this.modalDataMission?.employee &&
			!this.modalDataMission?.mission?.missionParent
		);
	}

	/**
	 *
	 * @returns false si secteur mission incompatible avec emp ; true sinon
	 */
	isMissionAreaMatchingForEmp(): boolean {
		if (this.facade.dataStorageService.isAreaActive()) {
			const missionAreaId: number =
				this.modalDataMission.mission.missionRequest.beneficiaire?.area?.id;
			if (missionAreaId) {
				const empAreaIds: number[] = this.modalDataMission.employee.areas?.map(
					(area) => area.id
				);
				if (empAreaIds && empAreaIds.length > 0) {
					return empAreaIds.includes(missionAreaId);
				}
			}
		}
		return true;
	}

	getVehicleOfMission(missionId: number): Vehicle {
		if (this.solution) {
			const vehicle = this.solution.plannings
				.flatMap((planning) => planning.routes)
				.filter(
					(route) =>
						route?.missions.findIndex((mission) => mission.id === missionId) >
						-1
				)
				.map((route) => route?.vehicle);
			if (vehicle && vehicle.length === 1) {
				return vehicle[0];
			}
		}
		return null;
	}

	hasEventAlreadyHappened(mission: Mission) {
		return (
			new Date(mission.missionRequest.date).getTime() +
				mission.realEnd * 60 * 1000 <
			new Date().getTime()
		);
	}

	getVehicules() {
		this.facade.vehiculeService.getAllVehicule().subscribe({
			next: (vehicules: Vehicle[]) => {
				this.vehiculeList = vehicules;
			},
			error: (err) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.error(
					'' + err.status + ' ' + err.error.response ? err.error.response : ''
				);
			}
		});
	}

	changeStringDateIntoDate(stringDate: string | Date) {
		return new Date(stringDate);
	}

	openResolveConflictModal() {
		const initialState: ModalOptions = {
			initialState: {
				mission: this.modalDataMission.mission,
				overlappingResponse: this.modalDataMission?.overlappingResponse,
				employee: this.modalDataMission?.employee,
				initialEmployee: this.initialEmployee,
				selectedCalendarDate: this.selectedCalendarDate,
				getData: this.getDataForPlanning
			},
			class: 'modal-lg'
		};
		this.bsModalResolveConflict = this.bsModalService.show(
			ResolveConflictModalComponent,
			initialState
		);
	}

	isCurrentMissionOverlappingRoute(
		newStartMission: number,
		newEndMission: number
	): boolean {
		let isOverlapping = false;

		const travelTime =
			this.getEndTravelMission() - this.getStartTravelMission();

		const routeOfMission = this.solution.plannings
			.flatMap((planning) => planning.routes)
			.find(
				(route) =>
					route.missions.findIndex(
						(mission) => mission.id === this.modalDataMission.mission.id
					) > -1
			);

		if (!routeOfMission) {
			return false;
		}

		routeOfMission.missions.sort((a, b) => a.realStart - b.realStart);

		const indexOfCurrentMission = routeOfMission.missions.findIndex(
			(mission) => mission.id === this.modalDataMission.mission.id
		);
		routeOfMission.missions.forEach((mission, index) => {
			const missionTravelTime = mission.realTravelEnd - mission.realTravelStart;
			if (index > indexOfCurrentMission) {
				if (mission.realStart - missionTravelTime < newEndMission) {
					isOverlapping = true;
					return;
				}
			}
			if (index < indexOfCurrentMission) {
				if (mission.realEnd > newStartMission - travelTime) {
					isOverlapping = true;
					return;
				}
			}
		});
		return isOverlapping;
	}

	confirmEdit() {
		this.bsModalConfirmEdit.hide();
		const confirmed = true;
		this.validateModal(confirmed);
	}

	validateModal(confirmed?: boolean) {
		this.isValidateBtnDisabled = true;
		const listOfApiCalls$: Observable<any>[] = [];

		if (this.hasMissionDateChanged()) {
			if (!this.missionDateAreValid()) {
				this.toastService.createErrorToast(
					'La mission ne peut pas commencer après sa fin.'
				);
				this.isValidateBtnDisabled = false;
				return;
			}

			const newStartMission = this.dateUtils.convertFromDateToMinutes(
				this.updatedStartMissionDate
			);
			const newEndMission = this.dateUtils.convertFromDateToMinutes(
				this.updatedEndMissionDate
			);

			if (
				this.isSESSAD &&
				this.isCurrentMissionOverlappingRoute(newStartMission, newEndMission)
			) {
				this.toastService.createErrorToast(
					'Conflit des horaires avec les autres ' +
						this.labelInterventionPluralized +
						' de la tournée.'
				);
				this.isValidateBtnDisabled = false;
				return;
			}

			const oldDuration = this.modalDataMission.mission.missionRequest.duration;
			const newDuration = newEndMission - newStartMission;

			if (oldDuration !== newDuration && !confirmed) {
				this.bsModalConfirmEdit = this.bsModalService.show(
					this.confirmEditModal
				);
			} else {
				this.modalDataMission.mission.realStart = newStartMission;
				this.modalDataMission.mission.realEnd = newEndMission;

				listOfApiCalls$.push(
					this.facade.formationService.rescheduleMissionAndMissionRequest(
						this.modalDataMission.mission
					)
				);
			}
		}

		if (this.hasEmployeeChanged()) {
			this.logger.info("L'employee a été modifiée.");
			// Si une nouvelle employee a été sélectionnée
			if (this.modalDataMission.employee) {
				this.logger.info('Une nouvelle employee a été sélectionnée.');
				// Trouver l'id du planning dans lequel la mission doit être insérée
				const newPlanningId = this.getPlanningIdOfSelectedEmployee();
				// Mise à jour du planner
				this.modalDataMission.mission.planner = this.user.employee;
				if (newPlanningId) {
					listOfApiCalls$.push(
						this.facade.missionService.changeMissionPlanning(
							this.modalDataMission.mission.id,
							newPlanningId,
							this.modalDataMission.mission.planner.id
						)
					);
				} else {
					// le planning n'existe pas... on appelle changePlanning avec un id Employee + id Mission
					listOfApiCalls$.push(
						this.facade.missionService.changeMission(
							this.modalDataMission.mission.id,
							this.modalDataMission.employee.id,
							this.modalDataMission.mission.planner.id
						)
					);
				}
			} else {
				this.logger.info("L'employee a été désaffecté de la mission.");
				// Supprimer l'employee du planning si il y en avait une rattachée
				// à la mission, sinon ne rien faire
				listOfApiCalls$.push(
					this.facade.planningService.deleteMission(
						this.getPlanningIdOfFormerEmployee(),
						this.modalDataMission.mission.id,
						this.solution.serviceCenter.id
					)
				);
			}
		}

		if (this.hasNotesChanged()) {
			// si les notes sont vides, on set un espace pour éviter l'erreur "Required request body is missing" côté back
			// => les notes sont ainsi reset à une string avec un simple espace, et l'ancien contenu est bien supprimé
			const notesToSend =
				this.notesForm.value.notes !== '' ? this.notesForm.value.notes : ' ';
			listOfApiCalls$.push(
				this.facade.formationService.updateNotes(
					this.modalDataMission.mission.missionRequest.id,
					notesToSend
				)
			);
		}

		if (listOfApiCalls$.length <= 0) {
			if (this.isVehiculeActive && this.modalDataMission.mission.route) {
				this.validateVehicleChange();
			}
			this.bsModalMissionDetail.hide();
			this.isValidateBtnDisabled = false;
		}

		forkJoin(listOfApiCalls$).subscribe({
			next: () => {
				if (this.isVehiculeActive && this.modalDataMission.mission.route) {
					this.validateVehicleChange();
				}
				this.modalDataMission.action = 'Clicked';
				this.getDataForPlanning.emit({
					dateToLoad: this.selectedCalendarDate,
					reloadEmployeesAndVacation: false,
					reloadSolution: true,
					reloadOptimInProgress: false
				});
				this.modalDataMission.mission.missionRequest.notes =
					this.notesForm.value.notes;
				this.bsModalMissionDetail.hide();
				this.isValidateBtnDisabled = false;
			},
			error: (err: ErrorResponse | ErrorResponseWithMissionBody) => {
				if (err instanceof ErrorResponseWithMissionBody) {
					// TODO: gérer le cas où il y a plusieurs conflits
					this.isValidateBtnDisabled = false;
					this.modalDataMission.overlappingResponse = err.error[0];
					this.openResolveConflictModal();
				} else {
					// cf: return de "catchError()" dans HttpErrorInterceptor
					this.facade.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
					this.logger.log('' + err.status + ' ' + err.error.response);
					this.modalDataMission.action = 'Clicked';
					this.getDataForPlanning.emit({
						dateToLoad: this.selectedCalendarDate,
						reloadEmployeesAndVacation: false,
						reloadSolution: true,
						reloadOptimInProgress: false
					});
					this.bsModalMissionDetail.hide();
					this.isValidateBtnDisabled = false;
				}
			}
		});
	}

	validateVehicleChange() {
		const isModalDataRoute: boolean = !!this.modalDataRoute;
		const routeId = isModalDataRoute
			? this.modalDataRoute.route.id
			: this.modalDataMission.mission.route.id;
		const isVehicleSet = isModalDataRoute
			? !!this.modalDataRoute.route.vehicle
			: !!this.modalDataMission.mission.route.vehicle;
		const modalToClose = isModalDataRoute
			? this.bsModalRouteDetail
			: this.bsModalMissionDetail;
		if (isVehicleSet) {
			const vehicleId = isModalDataRoute
				? this.modalDataRoute.route.vehicle.id
				: this.modalDataMission.mission.route.vehicle.id;
			this.facade.routeService
				.addOrEditVehicleToRoute(routeId, vehicleId)
				.subscribe({
					complete: () => {
						this.logger.debug('Vehicle assigned');
						this.getDataForPlanning.emit({
							dateToLoad: this.selectedCalendarDate,
							reloadEmployeesAndVacation: false,
							reloadSolution: true,
							reloadOptimInProgress: false
						});
						modalToClose.hide();
					},
					error: (err) => {
						this.getDataForPlanning.emit({
							dateToLoad: this.selectedCalendarDate,
							reloadEmployeesAndVacation: false,
							reloadSolution: true,
							reloadOptimInProgress: false
						});
						this.toastService.createWarningToast(err.error.response);
						modalToClose.hide();
					}
				});
		} else if (!isVehicleSet && this.initialVehicle) {
			this.facade.routeService.removeVehicleOfRoute(routeId).subscribe({
				next: () => {
					this.logger.debug('Vehicle removed from route');
					this.getDataForPlanning.emit({
						dateToLoad: this.selectedCalendarDate,
						reloadEmployeesAndVacation: false,
						reloadSolution: true,
						reloadOptimInProgress: false
					});
					modalToClose.hide();
				},
				error: (err) => {
					this.getDataForPlanning.emit({
						dateToLoad: this.selectedCalendarDate,
						reloadEmployeesAndVacation: false,
						reloadSolution: true,
						reloadOptimInProgress: false
					});
					this.toastService.createWarningToast(err.error.response);
					modalToClose.hide();
				}
			});
		}
	}

	getEventLocation(givenMission?: Mission): string {
		const mission = givenMission || this.modalDataMission?.mission;

		const eventLocationLabel = mission.missionRequest.missionPlace
			? mission.missionRequest.missionPlace?.nameDisplay
			: 'Domicile du ' + this.labelBeneficiaire;

		return eventLocationLabel;
	}

	isMissionCanceled(mission: Mission): boolean {
		return mission.state
			? State[mission.state].includes(State.CANCELED)
			: false;
	}

	getReunionMembers() {
		const missionRequestOfReunionId = this.event.meta.mission.missionRequest.id;
		this.reunionMembers = this.solution.plannings
			.filter((planning) => {
				const missions = planning.routes
					.flatMap((route) => route.missions)
					.filter(
						(mission) => mission.missionRequest.id === missionRequestOfReunionId
					);
				return missions.length > 0;
			})
			.map((planning) => planning.employee);
		this.reunionMembersString = this.reunionMembers.map(
			(emp) => emp.firstName + ' ' + emp.lastName
		);
	}

	isMissionAReunion(mission?: Mission) {
		const missionToTest = mission || this.modalDataMission.mission;
		return (
			missionToTest.missionRequest.missionType.type === MissionTypeName.REUNION
		);
	}

	hasMissionTW(): boolean {
		if (this.isMissionAReunion() || this.isSESSAD || this.isSAE) {
			return false;
		} else {
			return true;
		}
	}

	hasEmployeeChanged(): boolean {
		return this.initialEmployee !== this.modalDataMission.employee;
	}

	hasNotesChanged(): boolean {
		return (
			this.notesForm.value.notes !==
			this.modalDataMission.mission?.missionRequest.notes
		);
	}

	hasVehicleChanged(): boolean {
		return this.initialVehicle !== this.modalDataRoute.route.vehicle;
	}

	hasMissionDateChanged(): boolean {
		return (
			this.initialStartDate.getTime() !==
				this.updatedStartMissionDate.getTime() ||
			this.initialEndDate.getTime() !== this.updatedEndMissionDate.getTime()
		);
	}

	missionDateAreValid(): boolean {
		return (
			this.updatedStartMissionDate.getTime() <
			this.updatedEndMissionDate.getTime()
		);
	}

	getStartMission(): number {
		if (this.hasMissionAlreadyHappened) {
			return this.modalDataMission.mission.realStart;
		} else {
			return this.modalDataMission.mission.plannedStart;
		}
	}

	getEndMission(): number {
		if (this.hasMissionAlreadyHappened) {
			return this.modalDataMission.mission.realEnd;
		} else {
			return this.modalDataMission.mission.plannedEnd;
		}
	}

	getStartTravelMission(): number {
		if (this.hasMissionAlreadyHappened) {
			return this.modalDataMission.mission.realTravelStart;
		} else {
			return this.modalDataMission.mission.plannedTravelStart;
		}
	}

	getEndTravelMission(): number {
		if (this.hasMissionAlreadyHappened) {
			return this.modalDataMission.mission.realTravelEnd;
		} else {
			return this.modalDataMission.mission.plannedTravelEnd;
		}
	}

	getPlanningIdOfSelectedEmployee(): number {
		const planningOfItfc = this.solution.plannings?.find(
			(planning) => planning.employee.id === this.modalDataMission.employee.id
		);
		if (planningOfItfc) {
			this.logger.log(
				`planning of ${planningOfItfc.employee.firstName} : ${
					planningOfItfc.routes.flatMap((route) => route.missions).length
				} missions found`
			);
			return planningOfItfc.id;
		} else {
			const planning = new Planning();
			if (this.initialEmployee) {
				planning.employee = this.initialEmployee;
				this.solution.plannings.push(planning);
			}
			return planning.id;
		}
	}

	getPlanningIdOfFormerEmployee(): number {
		if (this.initialEmployee) {
			const optPlanning: Planning = this.solution.plannings?.find(
				(planning) => planning.employee.id === this.initialEmployee.id
			);
			if (optPlanning) {
				return optPlanning.id;
			}
		}
		return null;
	}

	// Set modifications to modalDataMission
	setModificationsToModalDataMission() {
		if (this.modalDataMission.employee !== this.initialEmployee) {
			this.modalDataMission.employee = this.initialEmployee;
		}
		this.logger.log('mission modifiée');
	}

	updateEmployeeName(employee?: Employee) {
		this.logger.log('updateEmployeeName !');
		if (employee) {
			this.modalEmployeeName = employee.firstName + ' ' + employee.lastName;
			this.initialEmployee = employee;
		} else {
			this.modalEmployeeName = 'Aucun ' + PARAM_LABEL_INTERVENANT;
			this.initialEmployee = null;
		}
	}

	editModal() {
		if (
			this.solution &&
			!this.solution.validate &&
			!this.facade.dataStorageService.isIntervenant() &&
			!this.facade.dataStorageService.isProjectManager()
		) {
			this.modalDataMission.action = 'Edited';
			this.hasMissionAlreadyHappened =
				new Date(this.modalDataMission.mission.missionRequest.date).getTime() +
					this.modalDataMission.mission.plannedEnd * 60 * 1000 <
				new Date().getTime();

			if (this.modalDataMission.employee) {
				this.modalEmployeeName =
					this.modalDataMission.employee.firstName +
					' ' +
					this.modalDataMission.employee.lastName;
				this.initialEmployee = this.modalDataMission.employee;
			} else {
				// Pas d'employee pré-sélectionnée
				this.modalEmployeeName = null;
				this.initialEmployee = null;
			}
		}
	}

	editModalRoute() {
		if (
			this.solution &&
			!this.solution.validate &&
			!this.facade.dataStorageService.isIntervenant() &&
			!this.facade.dataStorageService.isProjectManager()
		) {
			this.modalDataRoute.action = 'Edited';

			if (this.modalDataRoute.route.vehicle) {
				this.modalVehicleName =
					this.modalDataRoute.route.vehicle.name +
					' - ' +
					this.modalDataRoute.route.vehicle.model;
				this.initialVehicle = this.modalDataRoute.route.vehicle;
			} else {
				// Pas d'employee pré-sélectionnée
				this.modalVehicleName = null;
				this.initialVehicle = null;
			}
		}
	}

	editModalVacation(vacation: Vacation): void {
		this.modalDataVacation.vacation = vacation;

		const startHours = new DateUtils().getFullDateFromDateAndMinutes(
			vacation.startDate,
			vacation.startTime
		);
		const endHours = new DateUtils().getFullDateFromDateAndMinutes(
			vacation.endDate,
			vacation.endTime
		);

		this.modalDataVacation.datetimeStart = startHours;
		this.modalDataVacation.datetimeEnd = endHours;

		this.modalDataVacation.employee = this.event.meta.employee;

		if (!this.isPlanif) {
			this.modalDataVacation.vacation.employeeId =
				this.modalDataVacation.employee.id;
		}

		this.modalDataVacation.action = 'Edited';
	}

	selectAbsenceType(type: VacationType): void {
		this.modalDataVacation.vacation.vacationType = type;
	}

	selectItfcAbs(intervenant: Employee): void {
		this.modalDataVacation.vacation.employeeId = intervenant.id;
		this.modalDataVacation.employee = intervenant;
	}

	selectVacationDate(): void {
		if (this.vacation.startDate !== this.vacationRangeDate) {
			this.vacation.startDate = this.vacationRangeDate;
			this.vacation.endDate = this.vacationRangeDate;
		}
	}

	validateVacationChange(): void {
		this.isAddingOrEditingVacationInProgress = true;
		this.modalDataVacation.vacation.startTime =
			this.modalDataVacation.datetimeStart.getHours() * 60 +
			this.modalDataVacation.datetimeStart.getMinutes();

		this.modalDataVacation.vacation.endTime =
			this.modalDataVacation.datetimeEnd.getHours() * 60 +
			this.modalDataVacation.datetimeEnd.getMinutes();

		this.facade.vacationService
			.updateVacationForEmployee(
				this.modalDataVacation.vacation,
				this.modalDataVacation.employee.id
			)
			.subscribe({
				next: (succ) => {
					this.modalDataVacation.action = 'Validate';
					this.getDataForPlanning.emit({
						dateToLoad: this.selectedCalendarDate,
						reloadEmployeesAndVacation: true,
						reloadSolution: true,
						reloadOptimInProgress: false
					});
					this.isAddingOrEditingVacationInProgress = false;
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
					this.logger.log(
						'' + err.status + ' ' + err.error.response ? err.error.response : ''
					);
					this.isAddingOrEditingVacationInProgress = false;
				}
			});
	}

	resetAction() {
		this.modalDataVacation.action = 'Reset';
	}

	confirmDelete() {
		if (
			this.vacation &&
			this.event?.meta?.vacation &&
			this.event?.meta?.employee
		) {
			this.facade.vacationService.deleteVacation(this.vacation.id).subscribe({
				next: (_) => {
					this.logger.log(`Vacation ${this.vacation.id} supprimée.`);
					this.getDataForPlanning.emit({
						dateToLoad: this.selectedCalendarDate,
						reloadEmployeesAndVacation: true,
						reloadSolution: false,
						reloadOptimInProgress: false
					});
					this.bsModalContentVacation.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err && err.error.response ? err.error.response : '',
						err?.status
					);
					this.logger.log(
						'' + err.status + ' ' + err.error.response ? err.error.response : ''
					);
				}
			});
		} else {
			this.logger.log('suppression impossible');
		}
		// this.modal.dismissAll();
	}

	openConfirmationDeleteVacationModal() {
		this.bsModalConfirmDelete = this.bsModalService.show(
			this.confirmDeleteModal,
			{ class: 'modal-lg' }
		);
	}

	openConfirmationCancelModal() {
		if (this.solution) {
			this.bsModalConfirmCancel = this.bsModalService.show(
				this.confirmCancelModal,
				{ class: 'modal-lg' }
			);
		}
	}

	returnSpecialites(specialties: Specialite[]) {
		return specialties.map((spec) => spec.name).join(',');
	}

	compareVehicule(vehiculeA: Vehicle, vehiculeB: Vehicle): boolean {
		return JSON.stringify(vehiculeA) === JSON.stringify(vehiculeB);
	}

	compareEmployee(employeeA: Employee, employeeB: Employee): boolean {
		return employeeA?.id === employeeB?.id;
	}

	isDeletable() {
		if (this.isPlanif || this.user.employee.id === this.vacation.employeeId) {
			return true;
		} else {
			return false;
		}
	}

	isEditable(mission: Mission) {
		this.user = new User({
			id: this.user.id,
			login: this.user.login,
			password: this.user.password,
			role: this.user.role,
			employee: this.user.employee,
			firstLogin: this.user.firstLogin
		});

		if (State[mission.state] && State[mission.state].includes(State.CANCELED)) {
			return false;
		}

		// On n'édite pas des missions groupées directement sur le planning
		if (this.isGroupMission) {
			return false;
		}

		if (this.facade.dataStorageService.isProjectManager()) {
			if (mission.planner?.id === this.user.employee.id) {
				return true;
			} else {
				return false;
			}
		} else if (this.facade.dataStorageService.isPlanificatrice()) {
			return true;
		}
		return false;
	}

	filterEmployeesListForProjectManager() {
		if (this.facade.dataStorageService.isProjectManager()) {
			return this.employeesList.filter(
				(employee) => employee.id === this.user.employee.id
			);
		} else {
			return this.employeesList.sort((emp1, emp2) => {
				return emp1.firstName.charCodeAt(0) - emp2.firstName.charCodeAt(0);
			});
		}
	}

	/**
	 *
	 * @returns Renvoi un boolean indiquant si la mission est supprimable (ie. elle est dans un intervalle de temps dans la passer en fonction de la date du jour)
	 */
	isCancelable(): boolean {
		return this.modalDataMission.mission.missionRequest.assignedToPlanning
			? true
			: this.modalDataMission.mission.planner !== null; //Avoir un planner signifie qu'un employee est affectée
	}

	confirmCancelation(reason: string): void {
		this.isCancelButtonClicked = true;
		this.facade.missionService
			.cancelMissionByMissionId(this.modalDataMission.mission.id, reason)
			.subscribe({
				next: () => {
					this.isCancelButtonClicked = false;
					this.modalDataMission.mission.state =
						reason === 'beneficiaire'
							? State.CANCELED_FOR_BENEFICIAIRE
							: reason === 'intervenant'
							? State.CANCELED_FOR_EMPLOYEE
							: reason === 'erreur planning'
							? State.CANCELED_PLANNING_ERROR
							: reason === 'erreur saisie'
							? State.CANCELED_TYPING_ERROR
							: reason === 'modifications'
							? State.CANCELED_INTERVENTION_MODIFY
							: reason === 'report'
							? State.CANCELED_POSTPONEMENT
							: reason === 'prescripteur'
							? State.CANCELED_FOR_PRESCRIBER
							: State.CANCELED;
					this.missionHasBeenManuallyCanceled = true;
					this.isStateOfMissionCanceled = true;

					this.bsModalConfirmCancel.hide();
					this.getDataForPlanning.emit({
						dateToLoad: this.selectedCalendarDate,
						reloadEmployeesAndVacation: false,
						reloadSolution: true,
						reloadOptimInProgress: false
					});
				},
				error: (err: ErrorResponse) => {
					this.isCancelButtonClicked = false;
					this.bsModalConfirmCancel.hide();
					this.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				}
			});
	}

	getCancellationReason(state: State): string {
		console.log(state);
		switch (state) {
			case State.CANCELED_FOR_BENEFICIAIRE:
				return 'absence du bénéficiaire';
			case State.CANCELED_FOR_EMPLOYEE:
				return "absence de l'intervenant";
			case State.CANCELED_PLANNING_ERROR:
				return 'erreur de planning';
			case State.CANCELED_TYPING_ERROR:
				return 'erreur de saisie';
			case State.CANCELED_INTERVENTION_MODIFY:
				return "modifications d'intervention";
			case State.CANCELED_POSTPONEMENT:
				return "report de date";
			case State.CANCELED_FOR_PRESCRIBER:
				return 'annulation par le prescripteur';
			default:
				return 'annulée';
		}
	}

	undoCancelMission(): void {
		this.facade.missionService
			.undoCancelMissionByMissionId(this.modalDataMission.mission.id)
			.subscribe({
				next: () => {
					this.modalDataMission.mission.state = this.StateMissionEnum.PENDING;
					this.isStateOfMissionCanceled = false;
					this.missionHasBeenManuallyCanceled = false;
					this.getDataForPlanning.emit({
						dateToLoad: this.selectedCalendarDate,
						reloadEmployeesAndVacation: false,
						reloadSolution: true,
						reloadOptimInProgress: false
					});
				},
				error: (err: ErrorResponse) => {
					this.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				}
			});
	}

	goBeneficiairePage(beneficiaireId?: number): void {
		this.modalDataMission
			? this.bsModalMissionDetail.hide()
			: this.bsModalRouteDetail.hide();
		const idBeneficiaire =
			beneficiaireId ||
			this.modalDataMission.mission.missionRequest.beneficiaire?.id;
		const link = ['/gestion/beneficiaires', idBeneficiaire];
		this.router.navigate(link);
	}

	goIntervenantPage(employeeId?: number): void {
		this.modalDataMission
			? this.bsModalMissionDetail.hide()
			: this.bsModalRouteDetail.hide();
		const idEmployee = employeeId || this.modalDataMission.employee.id;
		const link = ['/gestion/employees', idEmployee];
		this.router.navigate(link);
	}

	goPrestationPage(): void {
		this.bsModalMissionDetail.hide();
		const link = [
			'/gestion/formations',
			this.modalDataMission.mission.missionRequest.id
		];
		this.router.navigate(link);
	}

	goVehiclePage(vehicleId?: number): void {
		const idVehicle = vehicleId || this.modalDataRoute.route.vehicle.id;
		this.modalDataMission
			? this.bsModalMissionDetail.hide()
			: this.bsModalRouteDetail.hide();
		const link = ['/gestion/vehicules', idVehicle];
		this.router.navigate(link);
	}

	goToRoute(selectedRoute?: Route) {
		this.bsModalRouteDetail.hide();
		this.facade.dataStorageService.setParam(
			'selectedRouteIndex',
			selectedRoute.id
		);
		this.facade.dataStorageService.setParam('selectedDate', selectedRoute.date);

		const link = ['/routes/' + this.mappingState[selectedRoute.state]];
		this.router.navigate(link);
	}

	goMeetingPage() {
		this.bsModalMissionDetail.hide();
		const link = [
			'/gestion/meeting',
			this.modalDataMission.mission.missionRequest.id
		];
		this.router.navigate(link);
	}

	shouldDisplayRemoteLink() {
		const shouldDisplay =
			this.modalDataMission.mission.missionRequest.missionType.type ===
				MISSION_TYPE_PRESCRIPTION ||
			(this.modalDataMission.mission.missionRequest.remote &&
				this.modalDataMission.mission.missionRequest.remoteLink);
		return shouldDisplay;
	}
}
